<template>
	<div class="archive">
		<p style="text-align:center; font-size: 24px;margin-bottom: 10px;">
			Terms of Service
		</p>
		<p>
			THIS TERMS OF SERVICE (&quot;AGREEMENT&quot;) DESCRIBES THE TERMS AND CONDITIONS ON WHICH WE GRANT TO AN END
			USER (“YOU” OR “USER”) ACCESS TO MIAO PLAY ONLINE GAMES (&quot;MIAO PLAY&quot;) OR OTHER APPLICATIONS FOR
			MOBILE DEVICES (“APPS”) AND OTHER RELATED SERVICES (COLLECTIVELY THE “SERVICES”). BY ENTERING, USING,
			PLAYING OR OTHERWISE ACCESSING OUR SERVICES, YOU AGREE TO THIS AGREEMENT (AS MAY BE AMENDED FROM TIME TO
			TIME). PLEASE READ THE FOLLOWING INFORMATION CAREFULLY. IF YOU DO NOT AGREE TO THE TERMS AND CONDITIONS OF
			THIS AGREEMENT, PROMPTLY EXIT THIS PAGE AND STOP ACCESSING THE SERVICES.
		</p>
		<p>
			&nbsp;
		</p>
		<p>
			In this Agreement, “MIAO PLAY”, “we”, “us”, “our” refers to MIAO PLAY Singapore Pte. Ltd., including its
			joint ventures and related corporations as defined under the Companies Act of Singapore (Chapter 50).
		</p>
		<p>
			You must be at least 13 years of age to access and use the Services. If you are at least 13 years of age but
			below 18 years of age or such other age of majority required for this Agreement to be binding and
			enforceable against you and not voidable (“Age of Majority”), your parent or legal guardian must establish
			an Account with us. Parents and legal guardians who establish an Account with us for use by their child/ward
			or otherwise permit their child/ward access to the Services through their Account guarantee the compliance
			by the child/ward of the obligations under this Agreement. (Please also see Clause 4.)
		</p>
		<p>
			1. TERMS OF AGREEMENT
		</p>
		<p>
			&nbsp;
		</p>
		<p>
			Terms of Agreement. Our offer to allow you to use and access our Service (as we may choose to provide from
			time to time) is conditioned upon your agreement to all of the terms and conditions contained in this
			Agreement. In order to access certain Services, you may be given “just-in-time” notices or otherwise
			notified that you are required to agree to additional terms and conditions applicable to such Services in
			which you choose to participate. If you do not agree, you should not access or use such Services. Such
			additional terms and conditions including the Rules of Conduct are hereby incorporated in this Agreement by
			reference. Your use of Services constitute your agreement to all such terms and conditions.
		</p>
		<p>
			&nbsp;
		</p>
		<p>
			2. DESCRIPTION OF SERVICE
		</p>
		<p>
			&nbsp;
		</p>
		<p>
			We may offer access to the Services through the Internet at the Web Site, other MIAO PLAY branded websites,
			versions, Apps and third party services.
		</p>
		<p>
			We reserve the right to change the URL address of the Web Site at any time without prior notice.
		</p>
		<p>
			The Web Site, other MIAO PLAY branded websites and any Apps and any software/client program that we make
			available comprising, for and/or in connection with the Services (“Software”) are an active part of the
			Services and any use of the foregoing is governed by this Agreement.
		</p>
		<p>
			We do not represent, or warrant that the Services will be compatible with your browser or mobile device. In
			particular, we do not represent, or warrant that the Apps will be compatible with your mobile device.
		</p>
		<p>
			It is your sole responsibility to ensure that you use compatible web browser, mobile device and other
			equipment and software to access and use the Services.
		</p>
		<p>
			All fees incurred in accessing the Services shall be borne by you. In particular, please note that data
			charges may apply to your use of the Apps and for the avoidance of doubt, you are responsible for all data
			charges incurred in connection with the Apps. We do not provide Internet access, and you are responsible for
			all fees and costs associated with your Internet connection and fees charged by a location providing such
			internet access such as a cyber café, hotel or arcade; or costs of the computer or mobile device or other
			hardware or software.
		</p>
		<p>
			3. LICENSE TO USE
		</p>
		<p>
			Subject to your agreement to and compliance with the terms of this Agreement, we grant to you a
			non-exclusive, non-transferable, non-sharable, revocable, limited license to use the Services (including the
			Software in connection with the Services) solely for your personal, non-commercial use to the Services in
			accordance with this Agreement.&nbsp;
		</p>
		<p>
			We are entitled to immediately terminate this license, without any liability to you in the event of your any
			violation of the terms of this Agreement.
		</p>
		<p>
			The Services comprise of content that belongs to us and/or our licensors and that are protected by
			copyright, trademark, and other intellectual property laws. We reserve all rights, including without
			limitation, intellectual property rights and other rights, in respect of the Services. You may not use the
			Services or the intellectual property comprised in the Services in a manner that constitutes an infringement
			of our or our licensors’ rights. You shall not create, modify, adapt, reverse engineer, recompile,
			reproduce, publish or distribute any derivative works of any software, utilities, applications, simulators,
			tools, files or intellectual property derived from, forming or otherwise used to provide the Services, or
			otherwise use the Software and Services except as may be expressly provided in this Agreement or to the
			extent permitted by law or relevant open source licenses.
		</p>
		<p>
			You are not permitted to sell, auction, trade, sublicense, rent, lease, loan or transfer any Account,
			character, Game Resources or any copyrighted material, except as expressly permitted under Clause 6.&nbsp;
		</p>
		<p>
			Without prejudice to the generality of the foregoing, you shall not sublicense, rent, lease, loan, sell,
			auction, trade or otherwise transfer the Software for profit.
		</p>
		<p>
			You shall not use the Services and Account for any illegal purposes under applicable laws and/or
			regulations.
		</p>
		<p>
			4. ACCOUNT AND ACCESS TO SERVICES
		</p>
		<p>
			&nbsp;
		</p>
		<p>
			(a) Eligibility. You must be at least 13 years of age to access and use the Services. If you are at least 13
			years of age but below the Age of Majority, your parent or legal guardian must establish an Account with us.
		</p>
		<p>
			You are required to have an account (the &quot;Account&quot;) established with us in accordance with this
			Clause 4(a) or alternatively, if you have reached the Age of Majority, established with a third party
			service through which we permit access of the Services (such as Facebook Connect or the applications
			provider for your mobile device). If you access the Services through an Account with a third party service,
			you shall comply with its terms of service and agree to its privacy policy.
		</p>
		<p>
			By establishing an Account through which you access the Services, you undertake, represent and warrant that
			you have reached the Age of Majority. If you are at least 13 years of age but less than the Age of Majority
			and wish to use the Services, your parent(s) or legal guardian(s) must complete the registration process,
			open an Account in their name(s), and accept full responsibility for all obligations under this Agreement.
			Parents and legal guardians who establish an Account with us for use by their child/ward guarantee the
			compliance by the child/ward of the obligations under this Agreement.
		</p>
		<p>
			Only one person may use an Account to access the Services. The registered user of an Account may use the
			Account or may choose instead to permit their child/ward of the registered user to use the Account but such
			child/ward must be at least 13 years old.
		</p>
		<p>
			You shall not permit the use or access of the Services through your Account by your child/ward if they are
			below the age of 13 years old. You are liable for all activities conducted through your Account, whether or
			not authorized by you, including without limitation all purchases and in particular, parents or guardians
			are liable for all activities of their minor child conducted through the Account.
		</p>
		<p>
			You shall not create an Account or use any Services if you have been convicted of any sex offence or any
			crime involving moral turpitude.
		</p>
		<p>
			Any person whose Account or access through which has been suspended or terminated by us or any person who
			has been banned or removed from any Services may not access the Services in any manner or for any reason,
			including through any other Account, without our express written permission.
		</p>
		<p>
			You shall not use or access of the Services which is not provided or downloaded directly from our Web Site,
			or any other third party&#39;s platform without licensed by us.
		</p>
		<p>
			(b) Account ID. At the time your Account is opened, you may be required to choose a name to identify
			yourself (your &quot;Account ID&quot;).
		</p>
		<p>
			You shall not select as your Account ID a name which violates any third party&#39;s trademark right,
			copyright, or other proprietary right, or which may mislead others to believe you to be an employee of ours,
			or which we deem in our sole discretion to be vulgar or otherwise offensive.
		</p>
		<p>
			You shall not express, show, publish, announce any contents or act any activities which violates any third
			party&#39;s trademark right, copyright, or other proprietary right, or which may mislead others to believe
			you to be an employee of ours, or which we deem in our sole discretion to be vulgar or otherwise offensive,
			through your Account or under your Account ID.
		</p>
		<p>
			We reserve the right to delete, or to change, or terminate or suspend access through, any vulgar or
			otherwise offensive Account ID.&nbsp;
		</p>
		<p>
			You are solely liable for all activities conducted through your Account or under your Account ID.
		</p>
		<p>
			(c) Account. You agree that you do not own or have any property interest in the Account, the characters we
			store on our servers, the Free Game Resource or Premium Game Resource in the Account, or any other
			intellectual property or data which the Services, Software, other services, servers and Accounts are
			comprised of. The Account, characters, the Free Game Resource and Premium Game Resource, and any other
			intellectual property and data which the Services, Software, other services, servers and Accounts are
			comprised of, are properties of ours and/or our licensors and/or any relevant third party platform. All
			rights in and to the Services, characters, the Free Game Resource and Premium Game Resource, Software, other
			services, servers and Accounts shall inure to our benefit. We reserve all rights to maintain, manage,
			consolidate, switch, migrate, terminate, dispose, alter and administer our servers and the data of the
			Services for the provision of the Services as we may deem fit in our sole discretion without any liability
			to you whatsoever.&nbsp;
		</p>
		<p>
			(d) Character Name. In order to use the Services, you may be required to create a character for certain
			Services and choose a name for your character to identify your character to other Users (your
			&quot;Character Name&quot;). You may not select as your Character Name, a name that:
		</p>
		<p>
			&nbsp;
		</p>
		<p>
			(i)&nbsp; &nbsp; &nbsp; &nbsp;impersonates another person, whether another User, Non-Player Character
			(“NPC”) or game master or otherwise;
		</p>
		<p>
			(ii)&nbsp; &nbsp; &nbsp; may mislead others to believe you to be an employee of ours,
		</p>
		<p>
			(iii)&nbsp; &nbsp; &nbsp;is or may be illegal or protected by trade mark, copyright, or other proprietary
			right, or cause confusion;
		</p>
		<p>
			(iv)&nbsp; &nbsp; may be rude, humiliating, defamatory, vulgar, hurtful, threatening, abusive, obscene,
			libelous, hateful, offensive or racially, ethnically or otherwise objectionable including any name that is
			sexual in nature;&nbsp;
		</p>
		<p>
			(v)&nbsp; &nbsp; &nbsp;comprises of invalid characters or special characters or phrases or sentences or
			gibberish; or
		</p>
		<p>
			&nbsp;(vi)&nbsp; &nbsp; we otherwise deem, in our sole discretion, inappropriate, regardless of our
			software’s ability to disallow such names.
		</p>
		<p>
			You agree not to use any misspellings, alternative spellings or other actions in an attempt to circumvent
			the foregoing restrictions.
		</p>
		<p>
			We reserve the right to delete, remove, change or alter any Character Name that we deem to be inappropriate,
			in our sole discretion at any time.&nbsp;
		</p>
		<p>
			(e)Pledge Names, Pledge Titles, House Signs, Individual Titles, NPC Names. While accessing the Services, it
			may be possible to name your pledge, grant titles to individual Users, grant a title to your own character,
			name NPCs, or name a guild. The restrictions and other provisions regarding Character names (as described in
			sub-clause (d)) apply similarly to such names and titles that you choose or grant.
		</p>
		<p>
			&nbsp;(f) Passwords and Security. At the time your Account is opened, you must select a password. You are
			responsible for maintaining the confidentiality of your password and you are responsible for any harm
			resulting from your disclosure or allowing the disclosure of your password or from use by any person of your
			password to gain access to your Account and Account ID. At no time should you respond to an online request
			for a password, or use your Account, Account ID or password on any other platform without licensed by us. We
			will never ask for your password offline or online, except that you will be required to enter your password
			as part of the log-on process, or when you are requesting us to perform certain service that requires your
			password authentication, in which case you will only send your password to our designated email address or
			our Web Site.&nbsp;
		</p>
		<p>
			&nbsp;
		</p>
		<p>
			You agree to (a) notify us immediately if you are aware or reasonably suspect of any unauthorized use of
			your Account or password, and (b) ensure that you exit from your Account at the end of each session.
		</p>
		<p>
			(g) Registration Obligations. You agree to provide true, accurate, current and complete information about
			yourself as prompted by our registration form or if you access the Services through third party services,
			you represent and warrant that to the best of your knowledge true, accurate, current and complete personal
			information about yourself is and/or will be shared with us by such third party to pre-populate our
			registration form (&quot;Registration Data&quot;). You agree to maintain and promptly update the
			Registration Data to keep it true, accurate, current and complete. If any information provided to us is
			untrue, inaccurate, not current or incomplete, or we have reasonable grounds to suspect that such
			information is untrue, inaccurate, not current or incomplete, we have the right to suspend or terminate your
			Account and/or access through such Account and refuse any and all current or future use of the Service.
		</p>
		<p>
			(h) Terminated Accounts. Any person whose Account or access through which has been suspended or terminated
			by us may not access the Services in any manner or for any reason, including through any other Account,
			without our express written permission.
		</p>
		<p>
			(i) Related Accounts. If we terminate or suspend an Account or access through an Account, we may terminate
			or suspend any other Accounts or access through any other Accounts that share the same registrant’s name,
			phone number, email address, postal address, Internet Protocol address, or credit card number with the
			Account that, or access through which is, suspended or terminated.
		</p>
		<p>
			(j) Multiple Accounts. Currently, an Account holder is permitted to register more than one Account. However,
			we reserve the right to limit the number of Accounts each person may register or use to access the Services.
		</p>
		<p>
			(k) Right To Monitor and Remove Accounts and Contents. We have the right, but not the duty, to review and
			monitor all Accounts, all access to the Services, IP addresses, online communications and all content
			submitted for or included on the Services.&nbsp;
		</p>
		<p>
			You agree that we have the right to monitor, collect, use, remove, alter, suspend and disclose all such
			data, information and content as we, in our sole discretion, believe necessary or appropriate for provision
			of the Services, to investigate or resolve possible problems or inquiries, for any legal process, for
			compliance with any laws or regulations, to enforce the terms of this Agreement or in our good faith belief
			that it would aid in protecting the rights, property or safety of any person.
		</p>
		<p>
			We further reserve the right in our sole discretion to remove, suspend or terminate any Accounts and/or
			access through any Accounts and/or content that we find objectionable for any reason, or in the event of any
			breach of any terms of this Agreement, without any prior notice, without any liability whatsoever. Further,
			in addition to any other rights of ours under this Agreement (such as the right to terminate all Services
			and access thereto as provided under Clause 5(c)) or by law, we reserve the right to terminate any Account
			that has been inactive for one hundred eighty (180) days and has never paid any Premium Fee (as defined
			below), without any liability whatsoever.
		</p>
		<p>
			5. PREMIUM FEE
		</p>
		<p>
			You do not need to pay any access fee to us to use the Services unless you want to pay the Premium Fee for
			permission to play the premium game resource, where you will be given access to game points and/or game
			currency and/or game items etc. (“Premium Game Resource”). The Premium Fee paid by you will provide you the
			access to play the premium game resource for a period of one (1) month from the date of purchase, after
			which, we may, in our sole direction at any time, terminate the Services under this Agreement. As long as we
			continue to provide the Services to the public, we will not expire your access to Premium Game Resources,
			unless you violate any term of this Agreement.
		</p>
		<p>
			&nbsp;
		</p>
		<p>
			The premium game resource may be available as a monthly or another periodic subscription. Your subscription
			to the premium game resource is deemed as your consent to the Subscription Policy and to the corresponding
			direct debit or other payment method. If your subscription is purchased through one of our Services, you
			will be charged for such subscription Your subscription will be automatically renewed on a monthly or
			another periodic basis until either party cancels or terminates the subscription. You have to cancel or
			terminate the subscription before the commencement of the next month or the next period, otherwise the
			subscription will be automatically renewed and charged via your chosen payment method. You may cancel or
			terminate the subscription in accordance with the relevant Subscription Policy.
		</p>
		<p>
			You agree not to pay the Premium Fee by exploiting the bugs in the Services, on the Web Site, and/or within
			our Services and system which may cause unfair transaction between you and MIAO PLAY or gain unfair
			advantage in the Services, or through informal channels which are not provided directly by MIAO PLAY, or any
			other channels unauthorized by MIAO PLAY (the Unauthorized Channels). You undertake any loss due to paying
			the Premium Fee through Unauthorized Channels. For any Account found to pay through the Unauthorized
			Channels, we reserve the right to reduce, suspend, alter, delete or terminate the Account, or its data; we
			also have the right to identify it as a fraud, in our sole discretion.
		</p>
		<p>
			(a) Promotion Program
		</p>
		<p>
			We may as a gesture of goodwill and in our sole discretion, in the light of our budgeted operation costs,
			allow you to use the Services with only the free game resource which shall refer to the basic game items and
			other items as we may decide from time to time in our sole discretion (“Free Game Resource”). This promotion
			program is conducted by us at no charge and you agree and acknowledge that we are under no obligation to
			allow you access to the Free Game Resource and we may terminate this promotion program and/or any and all
			Services or your access thereto (subject to Clause 5(c)(ii)) at any time in our sole discretion, without any
			liability to you whatsoever.
		</p>
		<p>
			&nbsp;
		</p>
		<p>
			(b) Pay the Premium Fee for permission to play the Premium Game Resource
		</p>
		<p>
			The payment of the Premium Fee shall be on the terms as set out in this Agreement, in particular, Clause
			5(c)(i) and Clause 5(d) and not on a pre-paid advance basis.&nbsp; In consideration of your payment of the
			Premium Fee, we shall offer to you a limited permision to access such Premium Game Resource as we may
			stipulate on the Web Site, from time to time. You may first be given an MIAO PLAY Points Card (the “Points
			Card”) that represents a certain amount of MIAO PLAY Points which can be exchanged to other Premium Game
			Resource, such as MIAO PLAY points, MIAO PLAY currency, or MIAO PLAY Items for the Services. If you choose
			to pay by using Credit Cards, PayPal, Apple Pay, Google Play, and such other payment instruments and
			channels (such as through Facebook Credits) as we may permit from time to time, your payment will be
			processed by the relevant merchant service provider and/or other relevant third party. All parents and legal
			guardians are liable for any use of their credit cards and other payment instruments and channels by their
			child/ward. You agree to the terms of service and privacy policy of any third party that provide such
			payment channels or instruments that you choose to use.
		</p>
		<p>
			If you select to play a Free Game Resource or Premium Game Resource (collectively, the “Game Resource”), you
			agree that you have understood how the Game Resource is used in the Services and are fully responsible for
			all the consequences related to the use or transfer of such Game Resource.
		</p>
		<p>
			Notwithstanding the terminology that you “buy” or “earn” or “win” or “take possession of” any Game Resource
			or that we have “delivered” to you any Game Resource including without limitation any virtual game currency
			or other similar terminology, you acknowledge that you do not actually own the virtual game items or any
			credit balance in real currency or its equivalent and are not entitled to reimbursement of or exchange for
			any “real-world” monies or monetary value. You agree that the Game Resource you access (and all underlying
			intellectual property) are properties of ours and what you obtain is merely a limited license to access such
			Game Resource in the Services in accordance with this Agreement. We also reserve the right to not grant
			access of the Game Resource to certain Users.
		</p>
		<p>
			(c) Payment Term
		</p>
		<p>
			(i) Cash On Delivery
		</p>
		<p>
			Upon receiving your payment of the Premium Fee, we are obliged to display Services in accordance with Clause
			5(c)(ii), and make delivery of the Premium Game Resource on a “Cash-On-Delivery” basis, and not on
			when-and-if-available basis (without prejudice to Clauses 11, 12, 13 and 16). In this regard, the delivery
			of the Premium Game Resource has occurred when you first have taken possession of the MIAO PLAY Points Cards
			or any other Premium Game Resource (i.e. when this is first delivered to your Account) upon your payment of
			the Premium Fee, as we would grant you permission to play such Premium Game Resource from, and accordingly
			the Restricted Game Life (as defined below) commences from, your payment of the Premium Fee (subject to
			processing time). You are encouraged to play the Premium Game Resource promptly and we shall not be liable
			to you in any manner (whether for the refund of the Premium Fee or otherwise) if you do not play the Premium
			Game Resource by the end of the Restricted Game Life (unless, and to such extent that, such failure to use
			is due to a breach by us of this Agreement).
		</p>
		<p>
			“Restricted Game Life” refers to the validity period of the Premium Game Resource pursuant to your payment
			of the Premium Fee, i.e. the period during which we have any obligations to you in relation to the Premium
			Game Resource and during which you are permitted to play the Premium Game Resource. The Restricted Game Life
			is a period of one (1) month commencing from the date of your payment of the Premium Fee. Upon the end of
			the Restricted Game Life, we no longer have any obligation to display the Services. Please also see the
			concessionary period for Services as stated in Clause 5(c)(ii) below.
		</p>
		<p>
			(ii) One (1) month Concessionary period to continue displaying game
		</p>
		<p>
			&nbsp;
		</p>
		<p>
			In this regard, you agree that we are only obliged to continue displaying Services for one (1) month from
			the date of your payment of the Premium Fee, which you agree is a reasonable validity period. Thereafter,
			you agree and acknowledge that we may terminate any and all Services at any time in our sole discretion,
			without any liability to you whatsoever.
		</p>
		<p>
			For the avoidance of doubt, the foregoing is without prejudice to Clauses 11, 12, 13 and 16.
		</p>
		<p>
			(iii) Discharge of obligation
		</p>
		<p>
			You understand and agree that the performance by us of the various stages of the transactions as
			contemplated in this Agreement are completed and executed and all our obligations are discharged and
			extinguished upon the expiration of the one (1) month concessionary period.
		</p>
		<p>
			Thus, in substance, economic reality, and substantive law, you have no further rights to demand to play and
			we have no further obligation to display any Services for using, upon the expiration of the one (1) month
			concessionary period.
		</p>
		<p>
			For the avoidance of doubt, the foregoing is without prejudice to Clauses 11, 12, 13 and 16.
		</p>
		<p>
			(d) Return Policy.&nbsp; The act of downloading, viewing, or using such payment channels and instruments
			constitutes acceptance of their terms of service and privacy policy. Upon the payment of the Premium Fee by
			you, you agree that no Premium Game Resource (including MIAO PLAY Points Card) is eligible for return, and
			that the Premium Fee is not refundable, in whole or in part. You shall not be entitled to any concession in
			respect of this payment term. If any payment is disputed or charged back, the associated Account(s) or
			access through the associated Account(s) may be suspended, terminated, or other actions in our sole
			discretion, if any fraudulent activity is detected.&nbsp;
		</p>
		<p>
			(e) Security and Anti - Fraud. For security and anti-fraud purpose, we may require any User, whether prior
			to or after payment of the Premium Fee, to provide personal information such as name, address, phone number,
			social security number, and copy of picture ID. Users may also be required to write and sign a statement
			certifying that their purchases are authorized and legitimate. Failure to do so may result in suspension of
			the associated Account or of access through the associated Account.
		</p>
		<p>
			6. TRADING AMONG USERS
		</p>
		<p>
			&nbsp;
		</p>
		<p>
			All trading, sublicensing, renting, leasing, loaning, selling or transfers of Accounts, characters or Game
			Resource, including without limitation, trading of Account ID, Account Names, and all out-of-game transfers,
			are strictly prohibited. Further, any transactions in connection with the Game Resources or other Services
			amongst Users or provision of in-games services such as power-leveling for “real-world” payment or payment
			related to the Services is strictly prohibited, unless otherwise permitted by MIAO PLAY.
		</p>
		<p>
			You shall not access or use any Account or Game Resource pursuant to any sublicense, rent, lease, loan, sale
			or prohibited transfer arrangement.
		</p>
		<p>
			We are not responsible for any losses that occur, whether in relation to any trading activities. ANY AND ALL
			PROHIBITED CONDUCT MAY RESULT IN IMMEDIATE TERMINATION OF THE ACCOUNTS INVOLVED IN SUCH CONDUCT OR
			TRANSACTIONS OR TERMINATION OF ACCESS THROUGH ANY ACCOUNTS INVOLVED IN SUCH CONDUCT OR TRANSACTIONS.
		</p>
		<p>
			7. CONTENT AND USER CONDUCT
		</p>
		<p>
			&nbsp;
		</p>
		<p>
			(a) Content. You acknowledge that: (i) by using the Software and the Services you will have access to
			graphics, sound effects, music, animation-style video and text (collectively, &quot;Content&quot;), and (ii)
			Content may be provided under license by independent content providers, including text contributions from
			other Users (all such independent content providers shall hereinafter be referred to as &quot;Content
			Providers&quot;). We do not pre-screen Content as a matter of policy. We have the right, but not the
			obligation, to remove Content at any time at our sole discretion, in particular but without limitation any
			Content which we deem to be harmful, offensive, or otherwise in violation of this Agreement.
		</p>
		<p>
			(b) Rights in Content. You acknowledge that we and Content Providers have rights in our respective Content
			under copyright and other applicable laws, and that you accept full responsibility and liability for your
			use of any Content in violation of any such rights. You agree that you will not use any Content other than
			in connection with using Services.
		</p>
		<p>
			(c) User Content. Users can upload Content to our servers in various forms, such as in selections you make
			for Services and in bulletin boards and similar user-to-user areas. Unless specified otherwise in your
			transmission, by submitting your Content, you automatically grant (or you warrant that the owner of such
			Content has expressly granted) to us a royalty-free, perpetual, irrevocable, non-exclusive right and license
			to use, reproduce, modify, adapt, publish, translate, create derivative works from, distribute, perform and
			display such Content worldwide and/or to incorporate it in other works in any form, media, or technology now
			known or later developed. Other Users may use any Content you submit and we assume no responsibility for
			such use to any person, in particular, for any misuse or any compensation for any use. We hereby expressly
			reserve the right to limit our storage capacity for Users’ Content that you post on, through or in
			connection with the Services. We shall not be liable for any deletion or loss of any Content. You further
			agree that your Content may be deleted or removed by us at any time as we deem fit in our sole discretion.
		</p>
		<p>
			(d) Prohibited Conduct. You agree not to: (i) upload, post, e-mail or otherwise transmit Content that
			infringes any third party rights; (ii) impersonate any person or entity, including, but not limited to, our
			employee, or falsely state or otherwise misrepresent your affiliation with a person or entity; (iii) engage
			in, facilitate and/or promote any conduct that violates any law or regulation (including without limitation
			to upload, post, e-mail or otherwise transmit Content that violates any law or regulation); (iv) upload,
			post, e-mail or otherwise transmit Content as determined by us in our sole discretion that is harmful,
			threatening, abusive, harassing, tortuous, defamatory, vulgar, obscene, libelous, invasive of another&#39;s
			privacy, hateful, or racially, ethnically or otherwise objectionable; or contains any viruses, Trojan
			horses, worms, time bombs, cancel bots or other computer programming routines that are intended to damage,
			detrimentally interfere with, surreptitiously intercept or expropriate any system, data or personal
			information; (v) upload, post, email or otherwise transmit any Content that you do not have a right to
			transmit under any law or under contractual or fiduciary relationships (such as inside information,
			proprietary and confidential information learned or disclosed as part of employment relationships or under
			nondisclosure agreements); (vi) upload, post, email or otherwise transmit any repetitive messages,
			unsolicited or unauthorized advertising, promotional materials, &quot;junk mail”, &quot;spam”, &quot;chain
			letters”, &quot;pyramid schemes”, or any other form of solicitation; (vii) circumvent the security measures
			of, hack into, interfere with, overburden or otherwise disrupt any MIAO PLAY environment or the MIAO PLAY
			experience or otherwise any Services or any servers, networks, computer system, website, router or any other
			Internet connected device, or disobey any requirements, procedures, policies or regulations of networks
			connected to the Services; (viii) &quot;stalk&quot; or otherwise harass another user; (ix) collect, solicit,
			harvest, intercept, mine or manipulate personal information or other data from or through the Service; (x)
			intercept or manipulate any proprietary communications protocol; (xi) assist with the carrying out of the
			prohibited conduct described herein.
		</p>
		<p>
			(e) Cheating and Hacking. To ensure fair play, you agree that you will not use or exploit any bugs, errors,
			or design flaws to obtain unauthorized access to the Service or to gain an unfair advantage over other
			players, or use or exploit of any cheating programs such as cheats, macros, bots, exploits, automation
			software, hacks, mods mouse simulators or unauthorised third party software etc., to use Services or
			otherwise modify or interfere with the Services or the MIAO PLAY experience. You shall not use these
			cheating programs or create or assist in the creation of cheating programs. In particular but without
			limitation, you agree not to use the Services to create or assist in the creation of cheats, macros, bots,
			exploits, automation software, hacks, mods mouse simulators or unauthorised third party software etc., to
			use the Services or otherwise modify or interfere with the Services or the MIAO PLAY experience. You further
			agree not to modify or caused to be modified any files that are part of the Services. Otherwise, we reserve
			the right to reduce, suspend, alter, delete or terminate your Account, or its data, in our sole discretion.
		</p>
		<p>
			(f) Modification of the Software. All Users must use the Software provided by us. We periodically update the
			Apps and other Software, with or without notifying you and all Users are required to use the latest version
			of the Software. You agree that we may automatically upgrade the version of the Software that has been
			downloaded. You are strictly prohibited from modifying the Software.
		</p>
		<p>
			(g) Exploitation of Program Bug. You are prohibited from exploiting any programming bugs in the Services, on
			the Web Site, and/or within our Services and system.
		</p>
		<p>
			8. OFFICIAL SERVICE
		</p>
		<p>
			We have designed Services for use only as offered by us. You agree to use Services only as offered by us and
			not through any other means not approved by us. You further agree not to create or provide any other means
			through which Services may be played or accessed by others, such as through server simulators. You shall not
			attempt to gain unauthorized access to the Services, Accounts, or computers, servers or networks connected
			to the Services, including without limitation by circumventing, manipulating or modifying any technological
			or security measures, devices or Software.
		</p>
		<p>
			You may not take any action which imposes an unreasonable or disproportionately large load on our
			infrastructure.
		</p>
		<p>
			9. PRIVACY
		</p>
		<p>
			(a) The personal information you provide us during registration is used for our internal purposes only. We
			use the information we have collected to learn what you like in order to improve the Service. Except as
			otherwise expressly permitted by this Agreement or as otherwise authorized by you, we will not give any of
			your personal information to any third party without your express approval. We do not guarantee the security
			of any of your private transmissions against unauthorized or unlawful interception or access by third
			parties. If you request any technical support, you consent to our remote accessing and review of the
			computer you load the Software onto for purposes of support and debugging. You agree that we may communicate
			with you via email and any similar technology for any purposes relating to the Services, the Software, and
			any services or software which may in the future be provided by us or on our behalf.
		</p>
		<p>
			(b) We can (and you authorize us to) disclose any information about you to private entities, law enforcement
			agencies, or government officials, as we, in our sole discretion, believe necessary or appropriate for
			provision of the Services, to investigate or resolve possible problems or inquiries, for any legal process,
			for compliance with any laws or regulations, to enforce the terms of this Agreement or in our good faith
			belief that it would aid in protecting the rights, property or safety of any person.
		</p>
		<p>
			(c) Your Account ID, profile picture, Character Name, and other details relating to your character in
			Services may be publicly available and disclosed in any event.
		</p>
		<p>
			(d) Please also see our Privacy Policy. Registration data and other information collected about or from you
			are subject to our Privacy Policy, the terms of which are incorporated herein. You should review our Privacy
			Policy to better understand how we collect and use data about you.
		</p>
		<p>
			&nbsp;
		</p>
		<p>
			10. USERS INTERACTIONS AND PARENTAL GUIDANCE&nbsp;
		</p>
		<p>
			We reserve the right, but are not obligated, to monitor or be involved in disputes between Users. While we
			may choose to monitor and take action (such as reduce, suspend, remove, delete, migrate and administer your
			Account, or its data) upon inappropriate game play, chat or links to the Services, it is possible that at
			any time there may be language or other material accessible on or through the Services that may be
			inappropriate, in particular for children, or offensive to some Users of any age. We cannot ensure that
			other Users will not provide content or access to content that parents or guardians may find inappropriate
			or that any User may find objectionable. We do not as a matter of policy pre-screen the Content of the
			materials or communications transmitted by each User. You are solely responsible for the interactions with
			other Users.&nbsp;
		</p>
		<p>
			In the event of any dispute with any Users, you agree to waive any rights you may have against us and not
			assert any claim against us or any of our joint ventures, related corporations (as defined under the
			Companies Act of Singapore), shareholders, partners, affiliates, directors, officers, employees, agents or
			suppliers (collectively, the “MIAO PLAY Group”) and shall release us and the rest of the MIAO PLAY Group
			from all damages, liabilities, losses, damages, judgments, claims, causes of action and expenses, including
			attorney’s fees and costs and actual, special, incidental, punitive, exemplary and consequential damages for
			loss of profits, goodwill, use or data arising from such dispute.
		</p>
		<p>
			11. INTERRUPTION OF SERVICES
		</p>
		<p>
			(a) We reserve the right to interrupt the Services from time to time on a regularly scheduled basis or
			otherwise with or without prior notice in order to perform maintenance.
		</p>
		<p>
			(b) You acknowledge that the Services may be interrupted for unforeseen circumstances or causes beyond our
			control, and we cannot guarantee that you will be able to access the Services or your Account whenever you
			may wish to do so. In any event, we shall not be liable for any interruption of the Services arising from
			unforeseen circumstances or causes beyond our reasonable control, including without limitation acts of God,
			acts or regulations of government, military authorities and political interferences with our activities,
			network, server or infrastructure failures or shortages of labour, fuel, energy or technological facilities.
		</p>
		<p>
			(c) Notwithstanding any other provision in this Agreement, we shall not be obligated to refund any&nbsp;
			portion of any Premium Fee or otherwise provide any compensation or have any liability by reason of any
			interruption of the Services&nbsp; by reason of any of the circumstances described in Clause 11(a) or 11(b).
		</p>
		<p>
			12. DISCLAIMER OF WARRANTIES
		</p>
		<p>
			WE PROVIDE THE SOFTWARE, THE ACCOUNT, THE SERVICES, PROMOTION PROGRAM, FREE GAME RESOURCE, PREMIUM GAME
			RESOURCE AND ALL OTHER SERVICES ON AN &quot;AS IS&quot; BASIS, AND HEREBY EXPRESSLY DISCLAIM ALL WARRANTIES
			OR CONDITIONS OF ANY KIND, WRITTEN OR ORAL, EXPRESS, IMPLIED OR STATUTORY, INCLUDING WITHOUT LIMITATION ANY
			IMPLIED WARRANTY OF TITLE, NONINFRINGEMENT, MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE. WITHOUT
			LIMITING THE FOREGOING, WE DO NOT WARRANT OR REPRESENT THAT THE SOFTWARE, THE ACCOUNT, THE SERVICES,
			PROMOTION PROGRAM, FREE GAME RESOURCE, PREMIUM GAME RESOURCE OR OTHER SERVICES WILL MEET YOUR REQUIREMENTS,
			OR THAT THE OPERATION OF THE SOFTWARE, THE ACCOUNT, THE SERVICES, PROMOTION PROGRAM, FREE GAME RESOURCE,
			PREMIUM GAME RESOURCE OR OTHER SERVICES WILL BE UNINTERRUPTED, ERROR-FREE, CONTINUOUS, SECURE, VIRUS-FREE,
			OR THAT THE DEFECTS IN THE SOFTWARE, THE ACCOUNT, THE SERVICES, PROMOTION PROGRAM, FREE GAME RESOURCE,
			PREMIUM GAME RESOURCE OR OTHER SERVICES WILL BE CORRECTED. WE DO NOT WARRANT OR MAKE ANY REPRESENTATION
			REGARDING THE USE OR THE RESULTS OF THE USE OF THE SOFTWARE, THE ACCOUNT, THE SERVICES, PROMOTION PROGRAM,
			FREE GAME RESOURCE, PREMIUM GAME RESOURCE OR ANY OTHER SERVICES OR RELATED DOCUMENTATION IN TERMS OF THEIR
			CORRECTNESS, ACCURACY, QUALITY, RELIABILITY, APPROPRIATENESS FOR A PARTICULARLY TASK OR APPLICATION, OR
			OTHERWISE. NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY US OR OUR AUTHORIZED REPRESENTATIVES SHALL
			CREATE A WARRANTY OR IN ANY WAY INCREASE THE SCOPE OF THIS WARRANTY. YOU ARE ENTIRELY RESPONSIBLE FOR AND
			ASSUME ALL RISK FOR USE OF THE SOFTWARE, THE ACCOUNT, THE SERVICES, PROMOTION PROGRAM, FREE GAME RESOURCE,
			PREMIUM GAME RESOURCE AND ALL OTHER SERVICES. YOU SHOULD NOT USE THE SOFTWARE, THE ACCOUNT, THE SERVICES,
			PROMOTION PROGRAM, FREE GAME RESOURCE, PREMIUM GAME RESOURCE OR ANY OTHER SERVICES IN HIGH-RISK ACTIVITIES
			WHERE SUBSTANTIAL DAMAGE COULD RESULT IF AN ERROR OCCURRED. WE DO NOT WARRANT OR REPRESENT THAT OUR SECURITY
			PROCEDURES WILL PREVENT THE LOSS OR IMPROPER ACCESS TO YOUR DATA. WE ARE NOT RESPONSIBLE FOR TRANSMISSION
			ERRORS OR CORRUPTION OR SECURITY OF INFORMATION CARRIED OVER TELECOMMUNICATION LINES OR FOR ANY FOUL/UNFAIR
			PLAY OR ANY BREACH OF THIS AGREEMENT BY ANY USER OR LOSS OF GAME RESOURCES OR RECORDS OR OTHER DATA (IN
			PARTICULAR BUT WITHOUT LIMITATION FOR LOSS OF GAME RESOURCES PURSUANT TO ANY PROHIBITED TRADING ACTIVITES).
		</p>
		<p>
			IN THE EVENT THAT WE CHOOSE TO GRANT ANY AWARDS OR PRIZES (WHETHER PURSUANT TO ANY MARKETING ACTIVITIES OR
			EVENTS OR OTHERWISE), ANY AWARD OR PRIZE MAY BE SUBSTITUTED OR WITHHELD BY US FOR ANY REASON WHATSOEVER AS
			WE MAY DEEM FIT IN OUR SOLE DISCRETION. YOU FURTHER AGREE THAT IN THE EVENT OF ANY CONTROVERSY OR CONFLICT
			OR DISPUTE WITH REGARD TO THE AWARD OR PRIZE OR OTHER RESULTS OF ANY ACTIVITY OR EVENT (INCLUDING WITHOUT
			LIMITATION DUE TO AN ERROR IN THE SYSTEM DISPLAY), THE DECISION BY US AS TO THE AWARD OR PRIZE OR WHETHER
			THE SAME IS TO BE GRANTED OR OTHERWISE AS TO THE RESULTS OF ANY ACTIVITY OR EVENT SHALL BE FINAL.&nbsp;
		</p>
		<p>
			13. LIMITATION OF LIABILITY
		</p>
		<p>
			(a) THE MAXIMUM AMOUNT OF OUR TOTAL LIABILITY TO YOU FOR ALL DAMAGES, LOSSES, AND CAUSES OF ACTION (WHETHER
			IN CONTRACT, TORT (INCLUDING NEGLIGENCE), OR OTHERWISE) SHALL NOT EXCEED THE TOTAL PREMIUM FEES PAID BY YOU
			TO US IN AND WITHIN THE SAME MONTH OF THE EVENT FROM WHICH SUCH LIABILITY ARISES. IN NO EVENT SHALL WE, OR
			ANY OF OUR JOINT VENTURES, RELATED CORPORATIONS (AS DEFINED UNDER THE COMPANIES ACT OF SINGAPORE),
			SHAREHOLDERS, PARTNERS, AFFILIATES, DIRECTORS, OFFICERS, EMPLOYEES, AGENTS OR SUPPLIERS, BE LIABLE TO YOU OR
			TO ANY THIRD PARTY FOR ANY SPECIAL, INCIDENTAL, CONSEQUENTIAL, PUNITIVE OR EXEMPLARY DAMAGES, INCLUDING
			WITHOUT LIMITATION, ANY DAMAGES FOR LOSS OF PROFITS, ARISING (WHETHER OR IN CONTRACT, TORT, STRICT LIABILITY
			OR OTHERWISE) OUT OF OR IN CONNECTION WITH THE SOFTWARE, THE ACCOUNT, THE SERVICES, PROMOTION PROGRAM, FREE
			GAME RESOURCE, PREMIUM GAME RESOURCE OR ANY OTHER SERVICES OR THIS AGREEMENT, WHETHER OR NOT WE MAY HAVE
			BEEN ADVISED THAT ANY SUCH DAMAGES MIGHT OR COULD OCCUR.
		</p>
		<p>
			(b) If you pay a Premium Fee for access to Premium Game Resource, you agree to release us and the MIAO PLAY
			Group from any and all liabilities related to your purchase and to your access, play and any other use of
			the Game Resource, except that we are responsible for delivering such Premium Game Resource to your Account
			and display of the Services in accordance with Clause 5(c) but without prejudice to any of our rights under
			this Agreement or by law, in particular the provisions set out in clauses 11, 12, 13 and 16.
		</p>
		<p>
			(c) You agree to release us and the MIAO PLAY Group from any and all liabilities related to any computer
			virus infection to your computer, whether it is through our server or third party activities.
		</p>
		<p>
			(d) To the fullest extent permissible under any applicable law, unless otherwise expressly provided herein,
			you agree that we will not be held responsible or liable for anything that occurs or results from accessing
			or using the Services (including without limitation any loss, costs, damages, claims, actions or liability
			arising from any breach of this Agreement or other acts by any User or other person or any deletion or
			removal of any Content or from the use, access and using of the Services and Game Resources) and you agree
			to release us and/or the MIAO PLAY Group from, and waive and not assert any claims you may have against us
			and/or the MIAO PLAY Group under any law of every kind and nature, whether known or unknown, suspected or
			unsuspected, fixed or contingent, arising out of or in any way related to any of the Services.
		</p>
		<p>
			(e) Notwithstanding any other provision in this Agreement, we shall not be liable for any delay or failure
			to perform any of our obligations under this Agreement or otherwise for any loss, costs, damages, claims,
			actions or liability arising from unforeseen circumstances or causes beyond our reasonable control,
			including without limitation acts of God, acts or regulations of government, military authorities and
			political interferences with our activities, network, server or infrastructure failures or shortages of
			labour, fuel, energy or technological facilities. Notwithstanding any other provision in this Agreement, we
			shall be excused from any delay or failure to perform arising from unforeseen circumstances or causes beyond
			our reasonable control and any such delay or failure shall not be a breach by us of our obligations under
			this Agreement.
		</p>
		<p>
			(e) You agree that the disclaimers, limitation of liability, releases, waivers contained in this Agreement
			shall apply to the fullest extent permitted by any applicable law. If you are a California resident, you
			hereby waive your rights under the California Civil Code section 1542 that provides that a general release
			does not extend to claims which the creditor does not know or suspect to exist in his favour at the time of
			executing the release, which if known by him must have materially affected his settlement with the debtor.
			Residents of other jurisdictions waive any similar rights under applicable and/or analogous laws.
		</p>
		<p>
			(f) Notwithstanding the foregoing, the exclusion of certain warranties or the limitation or exclusion of
			liability may not be permitted by relevant laws in certain instances. Therefore, some of the limitations
			herein may not apply to you. In particular, nothing herein shall affect the statutory rights granted to
			consumers or restrict any liability for death or personal injury arising from our negligence or fraud.
		</p>
		<p>
			14. UNCENSORED INFORMATION AND THIRD PARTIES
		</p>
		<p>
			Our linking to such third-party sites or tie-up with third parties for the provision of the Services does
			not imply an endorsement, guarantee, approval or sponsorship of such third parties, or the information,
			products or services offered by or through such third parties. We do not warrant that the third-party sites
			or their client programs will not contain viruses or otherwise impact your computer. In addition, we do not
			control in any respect any information, products or services that third parties may provide or their
			business practices and policies.
		</p>
		<p>
			YOU UNDERSTAND THAT CONTENT AND MATERIALS ON THE INTERNET MAY BE CREATED AND MAINTAINED BY THIRD PARTIES
			(SUCH AS USER MESSAGE BOARD) AND THAT PORTIONS OF SUCH MATERIALS MAY BE SEXUALLY EXPLICIT, OBSCENE,
			OFFENSIVE, OR ILLEGAL.
		</p>
		<p>
			&nbsp;
		</p>
		<p>
			IN NO EVENT SHALL WE BE LIABLE TO ANY PERSON OR ENTITY, EITHER DIRECTLY OR INDIRECTLY, WITH RESPECT TO THE
			CONDUCT OF ANY THIRD PARTY OR ANY MATERIALS, INFORMATION, PRODUCTS AND SERVICES FROM THIRD PARTIES, WHETHER
			SUCH THIRD PARTIES ARE OTHER USERS OR THIRD PARTY SERVICE PROVIDERS, VENDORS OR OPERATORS OF EXTERNAL SITES.
			YOU ASSUME TOTAL RESPONSIBILITY AND RISK FROM YOUR USE OF THE SERVICES AND INTERNET GENERALLY INCLDUING
			WITHOUT LIMITATION ANY OBLIGATIONS INCURRED IN YOUR DEALINGS WITH ANY THIRD PARTIES. WE DISCLAIM ANY AND ALL
			RESPONSIBILITY FOR CONTENT CONTAINED IN ANY THIRD PARTY MATERIALS PROVIDED THOUGH HYPERLINKS OR IN ANY OTHER
			FORMS AND ANY OTHER THIRD PARTY PRODUCTS AND SERVICES.
		</p>
		<p>
			15. INDEMNIFICATION
		</p>
		<p>
			&nbsp;
		</p>
		<p>
			AT OUR REQUEST, YOU AGREE TO DEFEND, INDEMNIFY AND HOLD HARMLESS US, THE MIAO PLAY GROUP, OUR LICENSEES,
			DISTRIBUTORS, CONTENT PROVIDERS, AND OTHER USERS OF THE SERVICES, FROM ALL DAMAGES, LIABILITIES, LOSSES,
			DAMAGES, JUDGMENTS, CLAIMS, CAUSES OF ACTION, CLAIMS, AND EXPENSES, INCLUDING ATTORNEYS&#39; FEES AND COSTS
			ON A FULL INDEMNITY BASIS, WHICH WE, THE MIAO PLAY GROUP, OUR LICENSEES, DISTRIBUTORS, CONTENT PROVIDERS,
			AND OTHER USERS MAY HEREAFTER INCUR, SUFFER, OR BE REQUIRED TO PAY, DEFEND, SETTLE (SUBJECT TO ANY
			LIMITATIONS SET FORTH IN THIS AGREEMENT), OR SATISFY AS A RESULT OR ARISING OUT OF YOUR USE OR MISUSE OF THE
			SOFTWARE, THE ACCOUNT, THE SERVICES, PROMOTION PROGRAM, FREE GAME RESOURCE, PREMIUM GAME RESOURCE OR ANY
			OTHER SERVICES OR ANY BREACH OF THIS AGREEMENT BY YOU.
		</p>
		<p>
			YOU AGREE THAT WE SHALL NOT BE OBLIGED TO BUT SHALL BE ENTITLED TO, AT YOUR EXPENSE, ASSUME THE DEFENCE AND
			CONTROL OF ANY MATTER FOR WHICH YOU ARE REQUIRED TO INDEMNIFY US AND YOU AGREE TO PROVIDE YOUR FULL
			CO-OPERATION AND ASSITANCE IN ANY SUCH CLAIMS, ACTIONS OR PROCEEDIINGS.
		</p>
		<p>
			16. TERMINATION
		</p>
		<p>
			&nbsp;
		</p>
		<p>
			(a) We may suspend your Account and/or access through your Account for an indefinite period of time,
			terminate your Account and/or access through your Account and/or terminate this Agreement (including your
			license to the Services, Software and other services) immediately and without notice if you breach this
			Agreement or any terms of service or privacy policy of any third party platform (such as Facebook or mobile
			platforms) or merchant service provider or if we, in our sole discretion, believe you to have willfully
			infringed any third party intellectual property rights, or if we are unable to verify or authenticate any
			information you provide to us, or upon Game play, chat or any user activity whatsoever which is, in our sole
			discretion, inappropriate, an abuse and/or in violation of the spirit of Services and other services
			(including without limitation the circumvention or manipulation of any term of this Agreement, in
			particular, the Rules of Conduct). Notwithstanding any other provision under this Agreement, if the Services
			or your Account or your access through your Account is suspended, terminated or cancelled for any of the
			foregoing reasons or length of time or if we terminate this Agreement under any such circumstances, you will
			lose access to your Account, the Services and Services characters including all Game Resources whether
			Premium Game Resource or Free Game Resource, and we shall not have any obligation to refund any fees you
			paid or provide any other compensation for unused Premium Game Resources or otherwise&nbsp; have any other
			liability to you whatsoever. We reserve the right to seek further legal remedies against you.
		</p>
		<p>
			&nbsp;(b) Notwithstanding any other provision herein, you acknowledge that we further reserve the right to
			discontinue and terminate our promotion program as described in Clause 5(a) and/or any and all Services and
			other services or your access thereto and all Accounts (subject to Clause 5(c)(ii) but without prejudice to
			any other of our rights under this Agreement or by law, in particular the provisions set out in clauses 11,
			12, 13 and 16) at any time in the light of our budgeted operation costs, and in such case, you will lose
			access to the Services characters including all Game Resources whether Premium Game Resource or Free Game
			Resource, and we shall not have any obligation to refund any fees you paid or provide any other compensation
			for unused Premium Game Resources or otherwise have any other liability whatsoever to you.
		</p>
		<p>
			(c) You acknowledge that we reserve the right to take action (in our sole discretion) including but without
			limitation, to maintain, manage, consolidate, switch, migrate, terminate, dispose, reduce, suspend,
			disclose, alter and administer your Account or Account ID, to delete, remove, suspend, disclose, change or
			alter your data, or to interrupt, suspend or terminate our Services to you, without prior notice, if you
			violated any term of this Agreement.
		</p>
		<p>
			17. CHOICE OF LAW AND VENUE
		</p>
		<p>
			&nbsp;
		</p>
		<p>
			This Agreement is governed by and shall be construed and enforced under the laws of Singapore, without
			applying any conflicts of law principles that would require application of the law of any other
			jurisdiction. You agree to submit to the personal exclusive jurisdiction in Singapore and any other court of
			competent jurisdiction chosen by us.
		</p>
		<p>
			In the event of any dispute arising out of or in connection with this Agreement, including any question
			regarding its existence, validity or termination, (a “Dispute”), we strongly encourage that a resolution
			first be sought through our Customer Support service.
		</p>
		<p>
			You agree that in the event that a resolution is not obtained through our Customer Support service, such
			Dispute shall be referred by you and may be referred by us to and finally resolved by arbitration in
			Singapore in accordance with the Arbitration Rules of the Singapore International Arbitration Centre
			(&quot;SIAC Rules&quot;) for the time being in force, which rules are deemed to be incorporated by reference
			in this clause. The Tribunal shall consist of three (3) arbitrators, with you appointing one (1) arbitrator
			and us appointing one (1) arbitrator and the third arbitrator to be selected by the two (2) arbitrators so
			appointed. The language of the arbitration shall be English.
		</p>
		<p>
			Notwithstanding any of the foregoing, you agree that we are entitled to submit such Dispute for resolution
			through any other dispute resolution mechanism including the courts of any jurisdiction and we shall further
			be entitled to seek any injunctive or other equitable relief in the event of any breach or anticipatory
			breach by you, without any obligations of providing any bond or surety or proof of damages.
		</p>
		<p>
			You irrevocably waive all rights to seek any injunctive or other equitable relief or to enjoin or restrain
			the operation or exploitation of the Services or any part thereof. You further irrevocably waive all rights
			to a class or representative action or as a named or unnamed member in a class, consolidated, representative
			or private attorney general action.&nbsp;
		</p>
		<br />
	</div>
</template>

<script>
	export default {
		name: 'ArchiveEN'
	}
</script>

<style scoped>
	.archive {
		text-indent: 3ch;
		padding: 5px 10px;
		font-size: 16px;
	}
</style>